module.exports = __webpack_public_path__ + "static/6-8281ccfa7d5e09a86b56e2c7d3bf051d.jpeg";